export default __webpack_public_path__ + "static/media/25.9e7829c0.png";